import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
// import "flatpickr/dist/themes/material_blue.css";

document.addEventListener("DOMContentLoaded", () => {
  const dateFields = document.querySelectorAll(".datepicker");

  if (dateFields.length > 0) {
    flatpickr(dateFields, {
      dateFormat: "d/m/Y",       // ISO format for DB
      altInput: true,            // pretty display
      altFormat: "d/m/Y",       // e.g. September 10, 2026
      allowInput: true           // let users type manually
    });
  }
});
